import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { RootState } from 'redux/store';

interface IADXSlice {
  accessories: any;
  vehicleModelSeries: string;
  modelMarketingName: string;
  modelYear: string;
  modelId: string | undefined;
  exteriorColorCode: string | undefined;
  exteriorColorIdent: string;
  exteriorColorName: string | undefined;
  interiorColorCode: string;
  interiorColorIdent: string | undefined;
  interiorColorName: string | undefined;
  totalAsConfigured: string;
}

const initialState: IADXSlice = {
  accessories: [],
  vehicleModelSeries: '',
  modelMarketingName: '',
  modelYear: '',
  modelId: '',
  exteriorColorCode: '',
  exteriorColorIdent: '',
  exteriorColorName: '',
  interiorColorCode: '',
  interiorColorIdent: '',
  interiorColorName: '',
  totalAsConfigured: '',
};

export const adxSlice = createSlice({
  name: 'adx',
  initialState,
  reducers: {
    setADXData: (state, action: PayloadAction<IADXSlice>) => {
      const {
        vehicleModelSeries,
        modelMarketingName,
        modelYear,
        modelId,
        exteriorColorCode,
        exteriorColorIdent,
        exteriorColorName,
        interiorColorCode,
        interiorColorIdent,
        interiorColorName,
        totalAsConfigured,
      } = action.payload;
      state.accessories = [];
      state.vehicleModelSeries = vehicleModelSeries || '';
      state.modelMarketingName = modelMarketingName || '';
      state.modelYear = modelYear || '';
      state.modelId = modelId || '';
      state.exteriorColorCode = exteriorColorCode || '';
      state.exteriorColorIdent = exteriorColorIdent || '';
      state.exteriorColorName = exteriorColorName || '';
      state.interiorColorCode = interiorColorCode || '';
      state.interiorColorIdent = interiorColorIdent || '';
      state.interiorColorName = interiorColorName || '';
      state.totalAsConfigured = totalAsConfigured || '';
    },
  },
});

export const { setADXData } = adxSlice.actions;

export const getADXData = (state: RootState) => {
  const data = {
    accessories: state.adx.accessories,
    vehicleModelSeries: state.adx.vehicleModelSeries,
    modelMarketingName: state.adx.modelMarketingName,
    modelYear: state.adx.modelYear,
    modelId: state.adx.modelId,
    exteriorColorCode: state.adx.exteriorColorCode,
    exteriorColorIdent: state.adx.exteriorColorIdent,
    exteriorColorName: state.adx.exteriorColorName,
    interiorColorCode: state.adx.interiorColorCode,
    interiorColorIdent: state.adx.interiorColorIdent,
    interiorColorName: state.adx.interiorColorName,
    totalAsConfigured: state.adx.totalAsConfigured,
  };
  return data;
};

export default adxSlice.reducer;
